import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ShieldAlert, Briefcase, ArrowLeft } from 'lucide-react';

export default function Unauthorized() {
  const location = useLocation();
  const attemptedEmail = location.state?.email;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-primary/5 p-4">
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10 mb-4">
              <ShieldAlert className="w-8 h-8 text-destructive" />
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2">Access Restricted</h1>
            <p className="text-muted-foreground">
              This portal is exclusively for BlueLux team members
            </p>
          </div>

          <div className="space-y-4 mb-6">
            {attemptedEmail && (
              <div className="bg-muted/50 rounded-lg p-4 border border-border">
                <p className="text-sm text-muted-foreground mb-1">Email attempted:</p>
                <p className="text-sm font-medium text-foreground break-all">{attemptedEmail}</p>
              </div>
            )}

            <div className="bg-muted/50 rounded-lg p-4 border border-border">
              <p className="text-sm text-foreground">
                Only email addresses ending with <span className="font-semibold">@bluelux.com</span> or{' '}
                <span className="font-semibold">@team.bluelux.com</span> can create accounts.
              </p>
            </div>
          </div>

          <div className="space-y-3">
            <Button 
              asChild 
              className="w-full"
              size="lg"
            >
              <a 
                href="https://bluelux.com/jobs" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2"
              >
                <Briefcase className="w-4 h-4" />
                View Career Opportunities
              </a>
            </Button>

            <Button 
              asChild 
              variant="outline" 
              className="w-full"
            >
              <Link to="/auth/login" className="inline-flex items-center justify-center gap-2">
                <ArrowLeft className="w-4 h-4" />
                Back to Login
              </Link>
            </Button>
          </div>

          <div className="mt-6 pt-6 border-t border-border text-center">
            <p className="text-xs text-muted-foreground">
              Current BlueLux team member with the correct email?{' '}
              <Link to="/auth/signup" className="text-primary hover:underline font-medium">
                Try again
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
